import { createRef, PureComponent, forwardRef } from 'react';
import ReactSelect from 'react-select';
import ReactAsyncSelect from 'react-select/async';
import ReactCreatableSelect from 'react-select/creatable';
import Tooltip, { ReactSelectTooltipWrapper } from 'components/Tooltip';
import { constant } from 'lodash';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';

// COMPONENTS
import { CLASSES } from 'components/Tooltip/Tooltip.styles';

// UTILS
import { intl as utilsIntl } from 'utils';

const SelectContainer = styled.div`
  position: relative;
  flex-grow: 1;
`;

const getTooltipClassName = (menuPlacement) => {
  if (menuPlacement === 'top') {
    return CLASSES.ALIGN_TOP;
  }

  return undefined;
};

class _Select extends PureComponent {
  static defaultProps = {
    className: '',
    components: undefined,
    disabled: false,
    loading: false,
    menuPlacement: undefined,
    placeholder: undefined,
    readOnly: false,
    styles: {},
  };

  state = {
    tooltipNodeAvailable: false,
    menuOpen: false,
  };

  componentDidMount() {
    this.setState({
      tooltipNodeAvailable: true,
    });
  }

  containerRef = createRef();
  tooltipContentRef = createRef();

  onMenuOpen = () => {
    this.setState({ menuOpen: true });
  };

  onMenuClose = () => {
    this.setState({ menuOpen: false });
  };

  render() {
    // @ts-expect-error TS(2339): Property 'placeholder' does not exist on type 'Rea... Remove this comment to see the full error message
    let { placeholder, components } = this.props;

    components = {
      IndicatorSeparator: constant(null),
      // @ts-expect-error TS(2339): Property 'components' does not exist on type 'Read... Remove this comment to see the full error message
      ...this.props.components,
    };

    // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    placeholder = utilsIntl.maybeTranslate(placeholder, this.props.intl);

    const styles = {
      menuPortal: () => ({}),
      input: () => ({}),
      // @ts-expect-error TS(2339): Property 'styles' does not exist on type 'Readonly... Remove this comment to see the full error message
      ...this.props.styles,
    };

    return (
      // @ts-expect-error TS(2769)
      <SelectContainer ref={this.containerRef}>
        {this.state.tooltipNodeAvailable && (
          <ReactSelect
            classNamePrefix="beem-react-select"
            {...this.props}
            styles={styles}
            // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
            className={`beem-react-select ${this.props.className || ''}`}
            // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
            isDisabled={this.props.disabled || this.props.readOnly}
            // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
            isLoading={this.props.loading}
            placeholder={placeholder}
            components={components}
            // @ts-expect-error TS(2769):  Type 'unknown' is not assignable to type 'HTMLElement'.
            menuPortalTarget={this.containerRef.current}
            onMenuOpen={this.onMenuOpen}
            onMenuClose={this.onMenuClose}
          />
        )}
        <Tooltip
          ref={this.tooltipContentRef}
          // @ts-expect-error TS(2322): Type '{ ref: RefObject<unknown>; className: string... Remove this comment to see the full error message
          className={getTooltipClassName(this.props.menuPlacement)}
          containerElement={this.containerRef.current}
          isShown={this.state.menuOpen}
          WrapperComponent={ReactSelectTooltipWrapper}
        />
      </SelectContainer>
    );
  }
}

// @ts-expect-error TS(2769): No overload matches this call.
export const Select = injectIntl(_Select);

class _AsyncSelect extends PureComponent {
  static defaultProps = {
    placeholder: undefined,
    loading: false,
    disabled: false,
    readOnly: false,
    components: undefined,
    menuPlacement: undefined,
  };

  render() {
    // @ts-expect-error TS(2339): Property 'placeholder' does not exist on type 'Rea... Remove this comment to see the full error message
    // eslint-disable-next-line prefer-const
    let { placeholder, components, forwardedRef, ...rest } = this.props;

    components = {
      IndicatorSeparator: constant(null),
      LoadingIndicator: constant(null),
      // @ts-expect-error TS(2339): Property 'components' does not exist on type 'Read... Remove this comment to see the full error message
      ...this.props.components,
    };

    // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    placeholder = utilsIntl.maybeTranslate(placeholder, this.props.intl);

    const styles = {
      menuPortal: () => ({}),
      // @ts-expect-error TS(2339): Property 'styles' does not exist on type 'Readonly... Remove this comment to see the full error message
      ...this.props.styles,
    };

    return (
      <ReactAsyncSelect
        classNamePrefix="beem-react-select"
        {...rest}
        ref={forwardedRef}
        styles={styles}
        // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
        className={`beem-react-select beem-react-select-async ${this.props.className || ''}`}
        // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
        isDisabled={this.props.disabled}
        // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
        isLoading={this.props.loading}
        placeholder={placeholder}
        components={components}
      />
    );
  }
}

// @ts-expect-error TS(2769): No overload matches this call.
const WrappedAsyncSelect = injectIntl(_AsyncSelect);

export const AsyncSelect = forwardRef((props, ref) => <WrappedAsyncSelect {...props} forwardedRef={ref} />);

export const _CreatableSelect = (props) => {
  let { placeholder, components } = props;

  components = {
    IndicatorSeparator: constant(null),
    ...props.components,
  };

  placeholder = utilsIntl.maybeTranslate(placeholder, props.intl);

  return (
    <ReactCreatableSelect
      classNamePrefix="beem-react-select"
      {...props}
      className={`beem-react-select beem-react-select-creatable
        ${props.className || ''}`}
      isDisabled={props.disabled}
      isLoading={props.loading}
      placeholder={placeholder}
      components={components}
    />
  );
};

_CreatableSelect.defaultProps = {
  loading: false,
  disabled: false,
};

export const CreatableSelect = injectIntl(_CreatableSelect);
